import { useGtag } from 'vue-gtag-next';

import { campaign } from '@/json/json_loader';
import { ActionBase } from '@/models/action_base';
import { KbnConst } from '@/utils/kbn';

import { generateActionExternalRedirect } from './use_action_external_redirect';

/**
 * カスタマイズアクション
 */
export class ActionCustomizing extends ActionBase {
  typeKbn = KbnConst.ACTION_TYPE_KBN_CUSTOMIZING;

  keyName?: string;

  use() {
    const externalRedirect = generateActionExternalRedirect().use();
    return async () => await execute(this.keyName, externalRedirect);
  }

  constructor(init: Partial<ActionCustomizing> = {}) {
    super();
    Object.assign(this, init);
  }
}

async function execute(
  keyName: string | undefined,
  externalRedirect: (url?: string) => Promise<boolean>,
) {
  if (keyName === 'redirect_liff') {
    return await externalRedirect(campaign.liffUrl);
  }

  // これらのカスタムタグの ID はおそらくテストと本番で異なるが、
  // index.html に設定するタグにも ID が入っており切り替えが大変なため、
  // 現状キー名や campaign.ts での指定はしない想定。

  if (keyName === 'click_event_x') {
    const twq = (window as any).twq;

    if (typeof twq === 'function') {
      twq('event', 'tw-omokm-omspb', {});
    }
  }

  if (keyName === 'click_event_meta') {
    const fbq = (window as any).fbq;

    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart');
    }
  }

  if (keyName === 'click_event_line') {
    const _lt = (window as any)._lt;

    if (typeof _lt === 'function') {
      _lt('send', 'cv', {
        type: 'Conversion',
      }, ['5d5f4e38-6a1f-48b7-bb67-d71da6f9ac11']);
    }
  }

  if (keyName === 'click_event_google') {
    const { event } = useGtag();

    // コールバックによるページ遷移は行わないため、event_callback は設定しない。
    event('conversion', {
      'send_to': 'AW-16536237673/m3ONCMav7YUaEOnsi809',
    });
  }

  // キー名を使って好きな処理を実行できる
  if (!['click_event_x', 'click_event_meta', 'click_event_line', 'click_event_google', 'redirect_liff'].includes(keyName || '')) {
    alert(`このアクションは未実装（キー名: ${ keyName }）`);
  }
  return false;
}

export function generateActionCustomizing(keyName?: string): ActionCustomizing {
  return new ActionCustomizing({
    keyName,
  });
}
